import { useEffect } from 'react'
import PropTypes from 'prop-types'
import Select from 'components/Select'
import Icon from 'components/Icon'
import AccountMenuItem from 'components/CommonUI/AccountMenuItem'
import PlaidAuthorization from 'components/ModalViews/PlaidAuthorization'
import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'
import { useExternalAccount } from 'utils/accountHooks'
import { useAction } from 'utils/actions'

const ExternalAccounts = ({
  label,
  showAddAccount,
  onSetAccount,
}) => {
  const { openModal } = useAction()
  const {
    externalAccounts,
    setActiveAccount,
    activeAccount,
  } = useExternalAccount()

  const handleOpenPlaid = () => {
    openModal(<PlaidAuthorization />)
  }

  useEffect(() => {
    onSetAccount(activeAccount)
  }, [activeAccount])

  return (
    <Select
      label="To Account"
      value={activeAccount?.id || -1}
      onChange={e => setActiveAccount(e.target.value)}
    >
      {externalAccounts?.map((item, idx) => (
        <MenuItem
          key={`externalAccounts_${item.id}`}
          className={item.id === activeAccount?.id ? 'active' : undefined}
          value={item.id}
        >
          <AccountMenuItem
            label={label}
            {...item}
          />
        </MenuItem>
      ))}
      {showAddAccount && (
        <MenuItem
          onClick={handleOpenPlaid}
        >
          <Stack
            display="grid"
            gridAutoFlow="column"
            gap={1}
            alignItems="center"
            alignContent="center"
            justifyContent="flex-start"
          >
            <Icon
              icon="Add"
            />
            Add an Account
          </Stack>
        </MenuItem>
      )}
    </Select>
  )
}

ExternalAccounts.propTypes = {
  showAddAccount: PropTypes.bool,
  onSetAccount: PropTypes.func,
}

ExternalAccounts.defaultProps = {
  onSetAccount: () => {},
}

export default ExternalAccounts